/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES API 【企業詳細】
 * PR TIMESの企業詳細画面用のAPI
 *
 * The version of the OpenAPI document: 1.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    YahooProofResponseResultData,
    YahooProofResponseResultDataFromJSON,
    YahooProofResponseResultDataFromJSONTyped,
    YahooProofResponseResultDataToJSON,
} from './YahooProofResponseResultData';

/**
 * yahoo_proof_api の 200 レスポンス
 * @export
 * @interface YahooProofResponse
 */
export interface YahooProofResponse {
    /**
     * result が存在するかどうか
     * @type {boolean}
     * @memberof YahooProofResponse
     */
    result: boolean;
    /**
     * 校正結果のリスト
     * @type {Array<YahooProofResponseResultData>}
     * @memberof YahooProofResponse
     */
    resultData: Array<YahooProofResponseResultData>;
    /**
     * ステータスコードの文字列
     * @type {string}
     * @memberof YahooProofResponse
     */
    status: string;
}

export function YahooProofResponseFromJSON(json: any): YahooProofResponse {
    return YahooProofResponseFromJSONTyped(json, false);
}

export function YahooProofResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): YahooProofResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'result': json['result'],
        'resultData': ((json['result_data'] as Array<any>).map(YahooProofResponseResultDataFromJSON)),
        'status': json['status'],
    };
}

export function YahooProofResponseToJSON(value?: YahooProofResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'result': value.result,
        'result_data': ((value.resultData as Array<any>).map(YahooProofResponseResultDataToJSON)),
        'status': value.status,
    };
}

